import { StepCheck, StepCheckSwitch } from '../../../components/pages/Book/MemoryBank/memoryBankTypes';
import { BookLocation } from '../bookLocation/bookLocation';
import { BranchAnalytics } from './BranchAnalytics';
import { BranchStep } from './BranchStep';

export enum BranchDetailTypes {
    ENDING = 'ending',
    STORY = 'story',
    CHOICE = 'choice',
}

export enum StepTypeMode {
    Regular = 'regular',
    Elimination = 'elimination',
}

export type Branch = {
    id: number;
    title: string;
    description: string;
    uuid: string;
    // null = end-of-story (no navigation target); 0 is not a valid branch id.
    gotoBranchId: number | null;
    x: number;
    y: number;
    locationId: number;
    bgColor: null;
    pos: null;
    location_title: string;
    bonus_content: boolean;
    links: [];
    traits: [];
    answers: [];
    type: BranchDetailTypes;
    steps_count: number;
    words_count: number;
    steps?: BranchStep[]
    analytics?: BranchAnalytics;
    switch?: StepCheckSwitch[],
    check?: StepCheck,
    stepTypeMode?: StepTypeMode;
    location?: BookLocation;
    // audioPath: base bucket URL WITHOUT path suffix (e.g. "https://bucket.s3.amazonaws.com/").
    // = getAudioBucketUrl() from editor-api/utils/aws.js — no "audio/custom/" appended.
    // convertBranchToForm derives it (or falls back to deriveAudioBucketUrl) when the
    // cached node lacks it, so the form resolves step audio without an extra fetch.
    audioPath?: string | null;
}
